import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

import { TooltipModule } from 'primeng/tooltip';
import { DatePickerModule } from 'primeng/datepicker';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { ClickOutsideModule } from 'ng-click-outside';

import { CoreModule } from '../../Core/core.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';

import { CommonBasicModule } from '../Basic/basic.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { LayoutModule } from '../Layout/layout.module';
import { MiscModule } from '../Misc/misc.module';
import { FilterModule } from '../Filter/filter.module';
import { MentionsModule } from '../Mentions/mentions.module';
import { PageBuilderModule } from '../PageBuilder/page-builder.module';
import { TargetingSharedModule } from '../TargetingShared/targeting-shared.module';
import { CommonDialogsModule } from '../Dialogs/common-dialogs.module';

import { ListPickerService } from './services/list-picker.service';
import { InteractionViewService } from './services/interaction-view.service';
import { DistributionPickerService } from './services/distribution-picker.service';

import { RhpContextsTakeoverComponent } from './components/RhpContextsTakeover/rhp-contexts-takeover.component';
import { RhpContextsComponent } from './rhp-contexts.component';
import { ListMembershipTabComponent } from './components/ListMembershipTab/list-membership-tab.component';
import { RecentCoverageTabComponent } from './components/RecentCoverageTab/recent-coverage-tab.component';
import { TwitterPostsIframeComponent } from './components/Entity/TwitterPostsIframe/twitter-posts-iframe.component';
import { EntityFullProfileComponent } from './components/Entity/entity-full-profile.component';
import { ProfileSectionComponent } from './components/Entity/ProfileSection/profile-section.component';
import { FullProfileDialogComponent } from './components/Entity/FullProfileDialog/full-profile-dialog.component';
import { EntityProfileDetailsComponent } from './components/Entity/ProfileDetails/entity-profile-details.component';
import { InteractionViewTabComponent } from './components/InteractionViewTab/interaction-view-tab.component';
import { InteractionCardComponent } from './components/InteractionViewTab/InteractionCard/interaction-card.component';
import { AddInteractionDialogComponent } from './components/InteractionViewTab/AddInteractionDialog/add-interaction-dialog.component';
import { StaffSearchTabComponent } from './components/StaffSearch/staff-search-tab.component';
import { StaffCardComponent } from './components/StaffSearch/StaffCard/staff-card.component';
import { ListPickerDialogComponent } from './components/ListPickerDialog/list-picker-dialog.component';
import { AffiliatesTabComponent } from './components/Affiliates/affiliates-tab.component';
import { AffiliateCardComponent } from './components/Affiliates/affiliate-card.component';
import { OutletCardComponent } from './components/OutletCard/outlet-card.component';
import { ContactEditorComponent } from './components/ContactEditor/contact-editor.component';
import { HandlesChipsComponent } from './components/ContactEditor/HandlesChips/handles-chips.component';
import { SubjectChipsComponent } from './components/ContactEditor/SubjectChips/subject-chips.component';
import { ContactCardComponent } from './components/ContactCard/contact-card.component';
import { InfluencerStreamsService } from '../../Discover/Targeting/components/InfluencerStreams/influencer-streams-service';
import { EntityListTabComponent } from './components/EntityListTab/entity-list-tab.component';
import { EntityListCardComponent } from './components/EntityListTab/EntityCard/entity-list-card.component';
import { RecommendedSearchSummaryComponent } from './components/RecommendedSearchSummary/recommended-search-summary.component';
import { RecommendedContactCardComponent } from './components/RecommendedContactCard/recommended-contact-card.component';
import { DistPickerDialogComponent } from './components/DistPickerDialog/dist-picker-dialog.component';
import { EmailComposerOvertakeComponent } from './components/InteractionViewTab/EmailComposerOvertake/email-composer-overtake.component';
import { TakeOverModule } from '../TakeOver/take-over.module';

const rhpContextDeclerations = [
    RhpContextsTakeoverComponent,
    RhpContextsComponent,
    ListMembershipTabComponent,
    RecentCoverageTabComponent,
    TwitterPostsIframeComponent,
    EntityFullProfileComponent,
    ProfileSectionComponent,
    FullProfileDialogComponent,
    EntityFullProfileComponent,
    EntityProfileDetailsComponent,
    InteractionViewTabComponent,
    InteractionCardComponent,
    AddInteractionDialogComponent,
    StaffSearchTabComponent,
    StaffCardComponent,
    ListPickerDialogComponent,
    AffiliatesTabComponent,
    AffiliateCardComponent,
    OutletCardComponent,
    ContactEditorComponent,
    HandlesChipsComponent,
    SubjectChipsComponent,
    ContactCardComponent,
    EntityListTabComponent,
    EntityListCardComponent,
    RecommendedSearchSummaryComponent,
    RecommendedContactCardComponent,
    DistPickerDialogComponent,
    EmailComposerOvertakeComponent
];

@NgModule({
    imports: [
        LocalizationModule,
        CommonModule,
        CommonBasicModule,
        FormsModule,
        MiscModule,
        LayoutModule,
        CommonFormsModule,
        TooltipModule,
        CoreModule,
        CommonDialogsModule,
        AutoCompleteModule,
        PopoverModule,
        SelectModule,
        InputTextModule,
        FilterModule,
        CoreDialogsModule,
        DatePickerModule,
        PageBuilderModule,
        ClickOutsideModule,
        TargetingSharedModule,
        MentionsModule,
        A11yModule,
        ReactiveFormsModule,
        TakeOverModule
    ],
    declarations: [
        ...rhpContextDeclerations
    ],
    exports: [
        ...rhpContextDeclerations
    ],
    providers: [
        ListPickerService,
        DistributionPickerService,
        InteractionViewService,
        InfluencerStreamsService,
    ]
})
export class RhpContextsModule { }
